import { ReactNode } from "react";

import Button from "@vfuk/core-button/";
import Heading from "@vfuk/core-heading";
import Spacing from "@vfuk/core-spacing";

import { Stack } from "../../Stack";
import "../../assets/styles/common.scss";

export type CeaseModalContentProps = {
  heading: string;
  subHeading: string | ReactNode;
  bodyHeading: string;
  body: string;
  confirmMessage: string;
  onConfirm: () => void;
  cancelMessage?: string;
  onCancel?: () => void;
  loading?: boolean;
  discardButtonAlign?: boolean;
};

export const CeaseModalContent = (
  props: CeaseModalContentProps
): JSX.Element => {
  return (
    <>
      <div role="dialog">
        <Spacing spacingLevel={{ top: 4, left: 7, right: 7 }}>
          <Heading size={2} weight={3} justify="center" text={props.heading} />
        </Spacing>
        <Spacing spacingLevel={{ top: 3, bottom: 5 }}>
          <Heading size={2} weight={1} justify="center">
            {props.subHeading}
          </Heading>
        </Spacing>

        <Spacing spacingLevel={{ top: 4, left: 7, right: 7 }}>
          <Heading
            size={1}
            weight={3}
            justify="center"
            text={props.bodyHeading}
          />
        </Spacing>
        <Spacing spacingLevel={{ top: 3, bottom: 5 }}>
          <Heading size={1} weight={1} justify="center" text={props.body} />
        </Spacing>

        <Stack align="end" justifyContent="center">
          {props.cancelMessage && (
            <Spacing spacingLevel={{ right: 4 }}>
              <Button
                width="auto"
                text={props.cancelMessage}
                onClick={props.onCancel}
              />
            </Spacing>
          )}
          <Button
            width="auto"
            appearance="alt1"
            text={props.confirmMessage}
            onClick={props.onConfirm}
            loading={props.loading}
          />
        </Stack>
      </div>
    </>
  );
};
